import React from 'react';
import {NestActions} from '../../../store/actionCreators';
import {Query} from 'react-apollo';
import {GET_NEST_DEVICES} from '../../../lib/graphQL/nest/queries';
import DeviceItem from '../components/DeviceItem/DeviceItem';
import DeviceList from '../components/DeviceList/DeviceList';

const DeviceQueryContainer = () => {
  return (
    <Query query={GET_NEST_DEVICES}>
      {({loading, error, data}) => {
        if (loading) {
          NestActions.setLoading();
          return null;
        }

        if (error) {
          NestActions.unsetLoading();
          // TODO: accessToken 없을 때도 Error 뜸
          console.log(`Error...${error}`);
          return null;
        }

        const deviceList = data.serviceProvider.devices.map(device => {
          if (!device.hasFan) {
            return null;
          }

          return (
            <DeviceItem key={device.deviceId}
                        deviceId={device.deviceId}
                        deviceName={device.deviceName}/>
          );
        });

        NestActions.unsetLoading();

        return (
          <DeviceList>
            {deviceList}
          </DeviceList>
        );
      }}
    </Query>
  );
};

export default DeviceQueryContainer;


// WEBPACK FOOTER //
// ./src/app/nest/containers/DeviceQueryContainer.js